<template>
    <el-dialog title="打印" :visible.sync="isSwitch" width="1200px" :before-close="setSwitchClose">
        <!-- 修改：将按钮容器固定到顶部 -->
        <div class="fixed-footer">
            <el-button type="primary" @click="setSwitchClose">关闭</el-button>
            <el-button type="primary" v-print="printOptions">打印</el-button>
            <span class="ml10" v-if="sealTrue"><el-checkbox v-model="checked"
                    @change="change()">打印印章</el-checkbox></span>
        </div>

        <div id="print-tag" class="print-tag">
            <div v-html="html"></div>
        </div>
    </el-dialog>
</template>

<script>
import print from 'vue-print-nb';
export default {
    directives: { print },
    props: {
        isSwitch: {
            type: Boolean,
            default: false
        },
        html: {
            type: String,
            default: ''
        },
        sealTrue: {
            type: Boolean,
            default: false
        },
        numsituation: {
            type: [String, Number],
            default: 0
        },
        checked: {
            type: Boolean,
            default: true
        },
        marginOfSeal: {
            type: Number,
            default: 155
        }
    },
    data() {
        return {
            printOptions: {
                id: 'print-tag',
                popTitle: ''
            },
        };
    },
    mounted() {
        this.$nextTick(() => {
            if (this.numsituation != 0) {
                const pageNextElements = document.querySelectorAll('.PageNext');
                const imageUrl = require('@/assets/images/seal.png'); // Webpack 处理路径
                const container = document.getElementById('stamp_2');
                switch (this.numsituation) {
                    case 1:
                        this.change1(pageNextElements, imageUrl, container);
                        break;
                    case 2:
                        this.change2(pageNextElements, imageUrl, container);
                        break;
                    case 3:
                        this.change3(pageNextElements, imageUrl, container);
                        break;
                }
            }
        });
    },
    methods: {
        setSwitchClose() {
            this.$emit('setSwitchClose');
        },
        change() {
            this.$emit('printSeal', this.checked);
            const pageNextElements = document.querySelectorAll('.PageNext');
            const imageUrl = require('@/assets/images/seal.png'); // Webpack 处理路径
            const container = document.getElementById('stamp_2');
            switch (this.numsituation) {
                case 1:
                    this.change1(pageNextElements, imageUrl, container);
                    break;
                case 2:
                    this.change2(pageNextElements, imageUrl, container);
                    break;
                case 3:
                    this.change3(pageNextElements, imageUrl, container);
                    break;
            }
        },
        change1(pageNextElements, imageUrl, container) {
            if (pageNextElements && this.checked) {
                pageNextElements.forEach((pageNext) => {
                    pageNext.innerHTML = `
                    <span class="bigtip">仅供海湾公司内部人员填写纸质合同使用</span>
                    <div style="margin-right:40px; float:right; position:relative; z-index: 1;" id="stamp_1">
                        <img src="${imageUrl}" style="right:0px; margin-top:-${this.marginOfSeal}px;" alt="Stamp">
                    </div>
                    `;
                });
                if (container) {
                    container.innerHTML = `
                        <img src="${imageUrl}" style="right:0px; margin-top:-${this.marginOfSeal}px;" alt="Stamp">
                    `;
                }
            }
            if (pageNextElements && !this.checked) {
                pageNextElements.forEach((pageNext) => {
                    pageNext.innerHTML = `&nbsp;`;
                });
                if (container) {
                    container.innerHTML = `
                       &nbsp;
                    `;
                }
            }
        },
        change2(pageNextElements, imageUrl, container) {
            if (pageNextElements && this.checked) {
                pageNextElements.forEach((pageNext) => {
                    pageNext.innerHTML = `
                        <span class="bigtip">仅供海湾公司内部人员填写纸质合同使用</span>
                    `;
                });
                if (container) {
                    container.innerHTML = `
                        <img src="${imageUrl}" style="right:0px; margin-top:-${this.marginOfSeal}px;" alt="Stamp">  
                    `;
                }
            }
            if (pageNextElements && !this.checked) {
                pageNextElements.forEach((pageNext) => {
                    pageNext.innerHTML = `&nbsp;`;
                });
                if (container) {
                    container.innerHTML = `
                       &nbsp;
                    `;
                }
            }
        },
        change3(pageNextElements, imageUrl, container) {
            if (pageNextElements && this.checked) {
                pageNextElements.forEach((pageNext,index) => {
                    pageNext.innerHTML = `
                    <div style="margin-right:40px;top:-10px; float:right; position:relative; z-index: -1;" id="stamp_1_${index}">
                        <img src="${imageUrl}" style="right:0px; margin-top:-${this.marginOfSeal}px;" alt="Stamp">
                    </div>
                    `;
                });
                if (container) {
                    container.style.top = '15px';
                    container.innerHTML = `
                        <img src="${imageUrl}" style="right:0px; margin-top:-${this.marginOfSeal}px;" alt="Stamp">
                    `;
                }
            }
            if (pageNextElements && !this.checked) {
                pageNextElements.forEach((pageNext) => {
                    pageNext.innerHTML = `&nbsp;`;
                });
                if (container) {
                    container.innerHTML = `
                       &nbsp;
                    `;
                }
            }
        }
    }
};
</script>

<style lang="scss">
.print-tag {
    @media screen {
        margin-top: 60px;
    }

    @media print {
        margin-top: 0;
        font-size: 12px;

        ol {
            display: block;
            list-style: decimal;
            margin-block-start: 1em;
            margin-block-end: 1em;
            padding-left: 40px;
            counter-reset: item;
        }

        ol li {
            list-style: decimal;
            font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
            line-height: 17px;
            display: list-item;
            list-style-position: outside;
        }
    }
    tr {
        table {

            th,
            td {
                padding: 3px !important;

            }
        }
    }

    /deep/body {
        font-size: 12px;
    }

    p {
        padding: 0px;
        margin: 0px;
        line-height: 17px;
        /*font-size: 10px;*/
    }

    #print_confirm {
        border-top: #999999 1px solid;
        width: 100%;
        padding-top: 4px;
        position: absolute;
        height: 30px;
        background-color: #5473ae;
    }

    #btn_print {
        margin-left: auto;
        width: 71px;
        cursor: pointer;
        margin-right: auto;
        height: 24px;
    }

    #barcode {
        width: 150px;
        height: 50px;
    }

    .PageNext {
        page-break-after: always;
    }

    .qrcode_div {
        position: absolute;
        right: 22px;
        width: 100px;
        top: 5px;
    }

    .bigtip {
        font-family: KaiTi;
        font-size: 45px;
        display: block;
        font-weight: bold;
        color: #cccccc;
        z-index: 1;
        position: absolute;
        line-height: 100%;
        text-align: center;
        height: 20%;
        width: 100%;
        margin-top: -500px;
        margin-left: -200px;
        opacity: 0.5;
        transform: rotate(40deg);
        -o-transform: rotate(40deg);
        -webkit-transform: rotate(40deg);
        -moz-transform: rotate(40deg);
    }
}

.el-dialog__body {
    padding: 0;
    overflow: auto;
    position: relative;
    /* Add this */
    font-size: 12px;
}

/* 新增样式：固定按钮到顶部 */
.fixed-footer {
    position: absolute;
    /* Change from sticky to absolute */
    top: 0;
    left: 0;
    right: 0;
    // background-color: white;
    // z-index: 1000;
    padding: 10px;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
}
</style>